import { useEffect, useState } from "react";
import api from "../lib/api";
import MovieCard from "../components/MovieCard";
import MovieDetailModal from "../components/MovieDetailModal";

export default function MyList() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const { data } = await api.get("/watchlist");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="my-list-page">
      <div className="px-6 md:px-12 max-w-[1500px] mx-auto">
        <span className="text-xs uppercase tracking-[0.3em] text-[#D9381E]">Curated for you</span>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter text-white mt-3">
          Shelf
        </h1>
        <p className="text-[#8A8A8A] mt-4 max-w-xl">
          Titles you've set aside for a proper evening. Tap any to start or clear it off the shelf.
        </p>

        {items.length === 0 ? (
          <div className="mt-16 border border-[#222] p-12 text-center" data-testid="my-list-empty">
            <p className="text-[#8A8A8A]">Nothing on the shelf yet — save something from the Library.</p>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
            {items.map((m) => (
              <MovieCard key={m.id} movie={m} onClick={setSelected} />
            ))}
          </div>
        )}
      </div>
      <MovieDetailModal movie={selected} open={!!selected} onClose={() => setSelected(null)} onWatchlistChange={load} />
    </div>
  );
}
